import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import DropdownMenuItem from '@stripcash/ui-kit/components/DropdownMenu/components/DropdownMenuItem';

import getUserBalance from 'users/helpers/getUserBalance';
import CommonHeader, { HeaderTheme } from 'common/components/Header';
import { getUnreadSelector } from 'common/reducers/news';
import {
  OVERVIEW_ACCOUNT_PATH,
  OVERVIEW_DASHBOARD_PATH,
} from 'common/selectors/sidebar/affiliates';
import { isUserLoggedInSelector } from 'users/selectors';
import usePrivateMode from 'common/helpers/usePrivateMode';
import { isIncarnatedConfigSelector } from 'common/selectors/config';

import s from './styles.module.css';
import renderHeaderChildren from './components/renderHeaderChildren';

const mapStateToProps = (state) => ({
  news: getUnreadSelector(state).length,
  isIncarnated: isIncarnatedConfigSelector(state),
  isUserLoggedIn: isUserLoggedInSelector(state),
  balance: getUserBalance(state),
});

const DropdownMenuLinkItem = (props) => (
  <DropdownMenuItem
    {...props}
    label={
      <Link className={s.link} to={OVERVIEW_ACCOUNT_PATH}>
        {props.label}
      </Link>
    }
  />
);

const dropdownItems = [
  {
    value: OVERVIEW_ACCOUNT_PATH,
    label: 'Account settings',
    component: DropdownMenuLinkItem,
  },
];

const Header = () => {
  const { isIncarnated, news, balance, isUserLoggedIn } =
    useSelector(mapStateToProps);
  const [isPrivate, handleModeChange] = usePrivateMode({
    initial: !isIncarnated,
    shouldSave: isUserLoggedIn && !isIncarnated,
  });

  return (
    <CommonHeader
      isPrivate={isPrivate}
      onModeChange={handleModeChange}
      news={news}
      balance={balance}
      theme={isIncarnated ? HeaderTheme.Incarnated : HeaderTheme.Affiliate}
      showBalance
      dropdownItems={dropdownItems}
      defaultPath={OVERVIEW_DASHBOARD_PATH}
      renderChildren={renderHeaderChildren}
    />
  );
};

export default Header;
